<a class="skip-link" href="#main-content">Skip to main content</a>

<div class="app-container">
  <header class="app-header">
    <button
      #menuButton
      type="button"
      class="menu-toggle"
      aria-label="Open workspace navigation"
      [attr.aria-expanded]="isNavOpen"
      (click)="openNavigation()"
    >
      <mat-icon aria-hidden="true">menu</mat-icon>
    </button>

    <a
      class="brand"
      routerLink="/dashboard"
      aria-label="Agent Gateway Platform home"
    >
      <span class="brand-mark" aria-hidden="true">
        <mat-icon class="brand-icon">auto_awesome</mat-icon>
      </span>
      <span class="brand-title">AI Evaluator</span>
    </a>

    <div class="header-context">Gateway control plane</div>

    <div class="header-context-controls" aria-label="Prototype context">
      <button type="button" class="context-pill"><mat-icon aria-hidden="true">cloud</mat-icon>Pre-production</button>
      <button type="button" class="context-pill"><mat-icon aria-hidden="true">schedule</mat-icon>24 hours</button>
      <label class="header-search">
        <mat-icon aria-hidden="true">search</mat-icon>
        <input aria-label="Find an agent" placeholder="Find an agent" />
      </label>
      <span class="header-demo-badge"><mat-icon aria-hidden="true">science</mat-icon> Demo data</span>
      <button type="button" class="arize-header-action" (click)="showDemoNotice('Arize links are placeholders in this prototype.')">
        <mat-icon aria-hidden="true">open_in_new</mat-icon>
        Arize
      </button>
    </div>

    <div class="header-actions">
      @if (isAuthEnabled) {
        @if (isLoggedIn) {
          <div class="user-pill">
            <span class="user-avatar"
              ><mat-icon aria-hidden="true">person</mat-icon></span
            >
            <span class="user-name">{{ userName }}</span>
          </div>
          <button
            mat-icon-button
            (click)="logout()"
            aria-label="Logout"
            matTooltip="Logout"
          >
            <mat-icon aria-hidden="true">logout</mat-icon>
          </button>
        } @else {
          <button mat-stroked-button (click)="login()" class="login-btn">
            <mat-icon aria-hidden="true">login</mat-icon>
            Sign in
          </button>
        }
      }
    </div>
    @if (demoNotice) {
      <div class="header-demo-notice" role="status">{{ demoNotice }}</div>
    }
  </header>

  <div class="main-content">
    @if (isMobile && isNavOpen) {
      <button
        type="button"
        class="nav-backdrop"
        aria-label="Close workspace navigation"
        (click)="closeNavigation()"
      ></button>
    }

    <aside
      class="side-nav-container"
      [class.mobile-open]="isNavOpen"
      [attr.aria-hidden]="isMobile && !isNavOpen ? 'true' : null"
      [attr.inert]="isMobile && !isNavOpen ? '' : null"
      aria-label="Workspace navigation"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="isMobile && isNavOpen"
    >
      <div class="sidebar-header">
        @if (isMobile) {
          <button
            type="button"
            class="drawer-close"
            aria-label="Close workspace navigation"
            (click)="closeNavigation()"
          >
            <mat-icon aria-hidden="true">close</mat-icon>
          </button>
        }
      </div>
      <app-side-nav />
    </aside>
    <main id="main-content" class="content-container" tabindex="-1">
      <router-outlet />
    </main>
  </div>
</div>
